import React from 'react';
import { Card, Heading, Layout } from '@vwfs-bronson/bronson-react';
import { Notification } from '@cp-shared-19/frontend-ui';
import { ContractHeader } from 'components/contracts/ContractHeader';
import { Contract, OperatingLeaseFinancialDetails } from 'cpes-common';
import { boundry } from '../contract-recalculation-form/ContractRecalculationFormValues';
import { TranslationFormat, useTranslationWithFormatting } from 'localization/useTranslationWithFormatting';

import { formatCpDate } from '@cp-shared-19/common-utilities';

type ContractRecalculationUiProps = {
    contract: Contract;
    financialDetails: OperatingLeaseFinancialDetails;
};
export const ContractRecalculationHeader: React.FC<ContractRecalculationUiProps> = ({ contract, financialDetails }) => {
    const { t, f } = useTranslationWithFormatting('contract-recalculation');
    const totalDurationPermittedInMonths = boundry.duration.maximum;
    const maximumMileagePermitted = boundry.distance.maximum;
    const currentMileage =
        financialDetails.mileageLastRecalculation ?? (boundry.distance.minimum + boundry.distance.maximum) / 2;
    const currentDuration = Math.round(
        formatCpDate(financialDetails.endDate).diff(financialDetails.startDate, 'M', true),
    );

    return (
        <>
            <div className="u-mb">
                <Card title="">
                    <ContractHeader contract={contract} />
                </Card>
            </div>
            <div className="u-mb">
                <Notification>
                    <React.Fragment key=".0">{t('info.text')}</React.Fragment>
                </Notification>
            </div>
            <div className="u-mb">
                <Layout>
                    <Layout.Item default="1/2" s="1/1">
                        <Card title="">
                            <Heading level={4}>{t('details.duration.title')}</Heading>
                            <p>
                                <strong>{t('details.current-label')}</strong>:{' '}
                                {f(currentDuration, TranslationFormat.NUMBER) + ' ' + t('duration-unit')}
                            </p>
                            <p>
                                <strong>{t('details.maximum-label')}</strong>:{' '}
                                {f(totalDurationPermittedInMonths, TranslationFormat.NUMBER) + ' ' + t('duration-unit')}
                            </p>
                        </Card>
                    </Layout.Item>
                    <Layout.Item default="1/2" s="1/1">
                        <Card title="">
                            <Heading level={4}>{t('details.mileage.title')}</Heading>
                            <p>
                                <strong>{t('details.current-label')}</strong>:{' '}
                                {f(currentMileage, TranslationFormat.NUMBER) + ' ' + t('distance-unit')}
                            </p>
                            <p>
                                <strong>{t('details.maximum-label')}</strong>:{' '}
                                {f(maximumMileagePermitted, TranslationFormat.NUMBER) + ' ' + t('distance-unit')}
                            </p>
                        </Card>
                    </Layout.Item>
                </Layout>
            </div>
        </>
    );
};
